const e = {
  name: "PlusSquareFilled",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2 5C2 3.34315 3.34315 2 5 2H19C20.6569 2 22 3.34315 22 5V19C22 20.6569 20.6569 22 19 22H5C3.34315 22 2 20.6569 2 19V5ZM13 7H11V11H7V13H11V17H13V13H17V11H13V7Z" fill="currentColor"/>
</svg>
  `
};
export {
  e as PlusSquareFilled
};
